import userServiceApi from "./userServiceApi";
import { getRequest } from "./http";

/**
 * Fetches partner members overview and persists microsite pending counts to sessionStorage.
 * @returns {{ fullMembSitePending, hubMembSitePending } | null}
 */
export const syncMicrositePendingCountsFromOverview = async (partnerId) => {
  if (!partnerId) return null;
  try {
    const res = await getRequest(
      userServiceApi.getPartnerMembersOverview(partnerId)
    );
    if (!res?.data) return null;

    const fullMembSitePending = res.data.micrositePendingCountFullMem;
    const hubMembSitePending = res.data.micrositePendingCountHubMem;

    sessionStorage.setItem("fullMembSitePending", fullMembSitePending);
    sessionStorage.setItem("hubMembSitePending", hubMembSitePending);

    return { fullMembSitePending, hubMembSitePending };
  } catch {
    return null;
  }
};
